import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";
import Strings from "../../utils/stringUtil";
import AppIcons from "../../utils/appIcons";
import { isMobile } from "../../utils/responsiveUtil";
import theme from "../../utils/themeUtil";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from "../../assets/styles/main.module.css";
import TextSize from "../../utils/textSizeUtil";

const TestimonialItem = ({ name, profileImage, profileText, startGroup, description }) => (
    <Box>
        <Grid container spacing={2}>
            <Grid
                item
                xs={12}
                md={3}
                style={{ textAlign: "center" }}
            >
                <img
                    src={profileImage}
                    alt={name}
                    width={isMobile ? "240" : "100%"}
                    style={{ margin: '0px auto' }}
                />
            </Grid>
            <Grid
                item
                xs={12}
                md={9}
                style={{ textAlign: "left" }}
            >
                <Box pl={isMobile ? 0 : 4}>
                    <Typography
                        style={{
                            fontSize: TextSize.size18,
                            color: theme.palette.lightBlack.main,
                            fontWeight: "bold",
                        }}
                    >
                        {name}
                    </Typography>
                    <Divider
                        sx={{
                            borderColor: theme.palette.primary.main,
                            borderWidth: '1px', // Thickness
                            marginY: 1,
                        }}
                    />
                    <Box mt={0.5}>
                        <Typography
                            style={{
                                fontSize: TextSize.size12,
                                color: theme.palette.grey.main,
                            }}
                        >
                            {profileText}
                        </Typography>
                    </Box>
                    <Box my={2.5}>
                        <img
                            src={startGroup}
                            alt={name}
                            width='134'
                        />
                    </Box>
                    <Box mt={2}>
                        <Typography
                            style={{
                                fontSize: TextSize.size14,
                                color: theme.palette.lightBlack.main,
                                lineHeight: '1.8'
                            }}
                        >
                            {description}
                        </Typography>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    </Box>
);

// Testimonials data
const testimonials = [
    {
        id: 1,
        name: 'Mahima',
        profileImage: AppIcons.memberImg1,
        profileText: Strings.entrepreneur,
        startGroup: AppIcons.startGroup,
        description: Strings.memberDes1,
    },
    {
        id: 2,
        name: 'Tahseen Syed',
        profileImage: AppIcons.memberImg2,
        profileText: Strings.entrepreneur,
        startGroup: AppIcons.startGroup,
        description: Strings.memberDes2,
    },
    // Add more testimonials as needed
];

function MemberCarousel() {
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
    };

    return (
        <React.Fragment >
            <Box className={styles.container}>
                {/* Testimonial Carousel */}
                <Box mt={5} mb={8} px={isMobile ? 2 : 10}>
                    <Box mb={3}>
                        <Typography
                            style={{
                                fontSize: isMobile ? TextSize.size22 : TextSize.size38,
                                color: theme.palette.black.main,
                                fontWeight: '600',
                                textAlign: isMobile ? 'center' : 'center'
                            }}
                            className="wow animate__animated animate__zoomIn animate__slow"
                        >
                            {Strings.whatOurMembersSay}
                        </Typography>
                    </Box>
                    {/* slider section */}
                    <Slider {...settings}>
                        {testimonials.map((testimonial) => (
                            <TestimonialItem
                                key={testimonial.id}
                                name={testimonial.name}
                                profileImage={testimonial.profileImage}
                                profileText={testimonial.profileText}
                                startGroup={testimonial.startGroup}
                                description={testimonial.description}
                            />
                        ))}
                    </Slider>
                </Box>
            </Box>
        </React.Fragment >
    );
}

export default MemberCarousel;
